export default __webpack_public_path__ + "images/6c44b73b5a8f348d920180d0e6135f92.svg";